export const formatPhoneNumber = (value) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  if (phoneNumber.length < 4) return phoneNumber;
  if (phoneNumber.length < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

export const validatePhoneNumber = (phoneNumber) => {
  const numbers = phoneNumber.replace(/\D/g, "");
  return numbers.length === 10;
};

/**
 * Normalize a US phone string to E.164 (+1XXXXXXXXXX), or "" when it isn't a
 * complete 10-digit (optionally 1-prefixed 11-digit) number. Returning "" lets
 * callers cheaply test "is this a dialable number yet?" as they type.
 */
export const toE164 = (phone) => {
  const digits = String(phone || "").replace(/\D/g, "");
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  if (digits.length === 10) return `+1${digits}`;
  return "";
};

export const splitPhoneNumber = (phoneNumber) => {
  const cleaned = phoneNumber.replace(/\D/g, "");
  return {
    areaCode: cleaned.slice(0, 3),
    phoneNumber: cleaned.slice(3),
  };
};

/**
 * Format an E.164-style phone number (e.g. "+14155550000") for display.
 *
 * Differs from `formatPhoneNumber` (which is geared toward as-you-type input
 * formatting and truncates to 10 digits): this strips a leading "+1"/"1"
 * country code, then formats the trailing 10 digits as "(XXX) XXX-XXXX".
 * Falsy / null / undefined / non-10-digit inputs render as "--".
 */
export const formatPhoneNumberDisplay = (phone) => {
  if (!phone) return "--";
  const cleaned = String(phone).replace(/\D/g, "");
  if (cleaned.length === 11 && cleaned.startsWith("1")) {
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phone;
};
